export default __webpack_public_path__ + "static/media/logo_fundo_640_640.0a28adbe.jpeg";